import { useNavigate } from "react-router-dom";
import {blogs} from "../sections/content_component/blogs";

const Blogs = () => {
  const navigate = useNavigate();

  const handleBlogClick = (blogId) => {
    // Navigate to blog detail page
    navigate(`/blog/${blogId}`);
  };

  const handleReadMore = (e, blogId) => {
    e.stopPropagation(); // Prevent triggering the parent div click
    navigate(`/blog/${blogId}/details`);
  };

  return (
    <section className="w-full bg-gray-50 py-16 px-4">
      <h2 className="text-3xl font-semibold text-center mb-10">All Blogs</h2>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
        {blogs.map((blog) => (
          <div
            key={blog.id}
            onClick={() => handleBlogClick(blog.id)}
            className="bg-white rounded-xl shadow-lg overflow-hidden cursor-pointer transform transition-all duration-300 hover:scale-105 hover:shadow-xl"
          >
            <img
              src={blog.image}
              alt={blog.title}
              className="w-full h-48 object-cover"
            />
            
            <div className="p-6">
              <h3 className="text-xl font-bold mb-2 text-gray-800">{blog.title}</h3>
              
              <div className="flex items-center gap-4 mb-3 text-sm text-gray-600">
                {blog.date && <span>📅 {blog.date}</span>}
                {blog.author && <span>✍️ {blog.author}</span>}
              </div>
              
              <p className="text-gray-600 mb-4 line-clamp-3">{blog.excerpt}</p>
              
              <div className="flex gap-2">
                <button
                  onClick={(e) => handleReadMore(e, blog.id)}
                  className="bg-gradient-to-r from-green-700 to-green-600 text-white px-4 py-2 rounded-lg font-semibold hover:from-green-800 hover:to-green-700 transition-all"
                >
                  Read More
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/blog/${blog.id}/ext`);
                  }}
                  className="bg-gradient-to-r from-blue-600 to-blue-500 text-white px-4 py-2 rounded-lg font-semibold hover:from-blue-700 hover:to-blue-600 transition-all"
                >
                  Add EXT
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Blogs;